module.exports = __webpack_public_path__ + "images/4.1790221230673.jpg";